import { render, staticRenderFns } from "./InvoicePrint.vue?vue&type=template&id=506b6c6c&scoped=true"
import script from "./InvoicePrint.vue?vue&type=script&lang=js"
export * from "./InvoicePrint.vue?vue&type=script&lang=js"
import style0 from "./InvoicePrint.vue?vue&type=style&index=0&id=506b6c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b6c6c",
  null
  
)

export default component.exports